module.exports = __webpack_public_path__ + "static/media/protectionIcon.3f616c49.svg";